import { Column, Entity, Index, OneToMany } from 'typeorm';
import { AlertBannerMapEntity } from './alert-banner-map.entity';
import { AuditEntity } from './audit.entity';
import { BaseEntity } from './base.entity';
import { ImportExportStoreEntity } from './import-export-store.entity';
import { NotificationGroupEntity } from './notification-group.entity';
import { ObjectFieldEntity } from './object-field.entity';
import { ObjectFormatterEntity } from './object-formatter.entity';
import { ProcessObjectEntity } from './process-object.entity';
import { RbacActionObjectEntity } from './rbac-action-object.entity';

@Index('_object__table_unique', ['table'], { unique: true })
@Entity('_object')
export class ObjectEntity extends BaseEntity {
	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('varchar', {
		name: '_table',
		nullable: true,
		unique: true,
		length: 255,
	})
	public table!: string | null;

	@Column('tinyint', { name: '_searchable', width: 1, default: () => "'0'" })
	public searchable!: boolean;

	@Column('text', { name: '_baseUrl', nullable: true })
	public baseUrl!: string | null;

	@Column('tinyint', { name: '_auditable', width: 1, default: () => "'0'" })
	public auditable!: boolean;

	@Column('tinyint', { name: '_canHardDelete', width: 1, default: () => "'0'" })
	public canHardDelete!: boolean;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@OneToMany(
		() => AlertBannerMapEntity,
		(alertBannerMap) => alertBannerMap.fkObjectIdReference2,
		{},
	)
	public alertBannerMaps!: Array<AlertBannerMapEntity>;

	@OneToMany(() => AuditEntity, (audit) => audit.fkObject, {})
	public audits!: Array<AuditEntity>;

	@OneToMany(
		() => ImportExportStoreEntity,
		(importExportStore) => importExportStore.fkObject,
		{},
	)
	public importExportStores!: Array<ImportExportStoreEntity>;

	@OneToMany(
		() => NotificationGroupEntity,
		(notificationGroup) => notificationGroup.fkObject,
		{},
	)
	public notificationGroups!: Array<NotificationGroupEntity>;

	@OneToMany(() => ObjectFieldEntity, (objectField) => objectField.fkObject, {
		cascade: true,
	})
	public objectFields!: Array<ObjectFieldEntity>;

	@OneToMany(
		() => ObjectFormatterEntity,
		(objectFormatter) => objectFormatter.fkObject,
		{ cascade: true },
	)
	public objectFormatters!: Array<ObjectFormatterEntity>;

	@OneToMany(
		() => RbacActionObjectEntity,
		(rbacActionObject) => rbacActionObject.fkObject,
		{},
	)
	public rbacActionObjects!: Array<RbacActionObjectEntity>;

	@OneToMany(
		() => ProcessObjectEntity,
		(processObject) => processObject.fkObject,
		{},
	)
	public processObjects!: Array<ProcessObjectEntity>;
}
